export default __webpack_public_path__ + "static/media/scroll.18986a40.svg";